import resizeSlotIFrame from './resizeSlotIFrame';

export default {
  resizeSlotIFrame,
};
